module.exports = __webpack_public_path__ + "img/img014.de28229f.png";